<template>
  <el-col style="padding: 1em;">
    <el-row>
      <el-col :span="24">
        <el-carousel v-if="cow != null && cow.length != 0" :interval="4000" type="card" height="400px">
        <el-carousel-item v-for="user in cow" @slideClick="showUser(user)" :key="user.o_id" style="max-width: 500px;">
            <el-card  shadow="hover" :body-style="{ height: 'inherit',  padding: '0px' }">
                <el-col style="height:inherit;" :span="24">
                  <div style="max-width: 600px; max-height: 330px; overflow: hidden;">
                    <img :src="user.image_uri == null ? '/images/profile_placeholder.png' : user.image_uri" style="width: 100%; height: inherit;">
                  </div>
                  <div style="padding: 8px;">
                    <span>{{ user.rank.name }} {{ user.firstName + ' ' + user.lastName }}</span>
                    <div class="list-subtext">
                      <time>{{ user.level.name }} of the Week</time>
                    </div>
                  </div>
                </el-col>
            </el-card>
        </el-carousel-item>
        </el-carousel>
        <div v-else style="border: 1px solid #e8e8e8; text-align: center; border-radius: 4px; margin: 8px;">
          <h6>No Users of the Week</h6>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="16">
      <el-col :sm="24" :md="10">
        <nxs-home-update-card>
        </nxs-home-update-card>
      </el-col>
      <el-col :loading="uod == null" :xs="24" :sm="12" :md="8">
        <el-card shadow="hover" class="box-card" :body-style="{ padding: '0px' }">
          <div slot="header" class="clearfix">
            <span>Uniform of the Day</span>
          </div>
          <el-table
            :data="uod"
            style="width: 100%">
            <el-table-column
              prop="class"
              label="Class">
            </el-table-column>
            <el-table-column
              prop="suod"
              label="UOD">
            </el-table-column>
            <el-table-column
              prop="luod"
              label="LLAB UOD">
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="6">
        <el-card shadow="hover" class="box-card" body-style="padding: 16px; padding-top: 8px;">
          <div slot="header" class="clearfix">
            <span>Documents</span>
          </div>
          <div>
            <div v-for="o in files" :key="o.name" class="text item" @click="!o.hasOwnProperty('data') ? null : navigatePDF('/f/pdf/'+o.name+'.pdf')">
              <div class="list-tile">
                <span class="list-title">{{o.title}}</span>
                <div style="display: flex">
                  <span class="list-subtext">{{ !o.hasOwnProperty('data') ? 'Not Available' : o.data.last_modified}}</span>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </el-col>
</template>

<script>
import nxsUserProfile from '../../shared/Profile.vue';
import nxsUpdateCard from './UpdateCard.vue';
import {mapFields} from 'vuex-map-fields';

export default {
    components: {'nxs-home-update-card': nxsUpdateCard},
    data() {
        return {};
    },
    computed: {
        ...mapFields([
            'user',
            'announcements',
            'users',
            'files'
        ]),
        cow() {
            var t = [];
            if(this.announcements == null || this.users == null)
                return t;
            this.announcements.filter((anoun) => {
                if(anoun.title.includes('COW')){
                    return true;
                }
                return false;
            }).forEach((cad) => {
                if(cad.text >= 0){
                    t.push(this.users.find((user) => user.o_id == cad.text));
                }
            });
            return t;
        },
        uod() {
            var j = [];
            if(this.announcements == null)
                return j;
            ['POC', 'AS100', 'AS200'].forEach((asc) => {
                var t = {};
                t.class = asc;
                this.announcements.filter((anoun) => {
                    return anoun.title.includes(asc) && anoun.title.includes('UOD');   
                }).forEach((anoun) => {
                    if(anoun.title.includes('LLAB')){
                        t.luod = anoun.text;
                    }else{
                        t.suod = anoun.text;
                    }
                });
                j.push(t);
            });
            return j;
        }
    },
    methods: {
        inTerm(update) {
            return this.selected_terms.find((t) => t == update.term.term) != null;
        },
        navigatePDF(url) {
            window.open(url, '_blank');
        },
        getFileInfo() {
            this.files.forEach((file) => {
                var route = '/api/v1/f/pdf/'+ file.name +'.pdf/metadata';
                this.axios.get(route,
                    {
                        headers: {'Content-Type': 'application/json'},
                        credentials: 'same-origin'
                    }).then((response) => {
                    this.$set(file, 'data', response.data);
                }).catch((err) => {
                    console.error(err);
                });
            });
        },
        showUser(user) {
            this.$showPanel({
                component: nxsUserProfile,
                props: {user_id: user.o_id},
                width: "300px"
            })
        }
    },
    mounted() {
        if(this.$route)
            this.$store.dispatch('pullAnnouncements');
        if(!this.files[0].data)
            this.getFileInfo();
    }
}
</script>
